// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2ckCD","content":"LoadingAlert_content__gD1j2"};